'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToProducts = ['one'];

  var pathToImages = ['images', action.product_id];

  switch (action.type) {

    case 'ADD_PRODUCT_START':
    case 'UPDATE_PRODUCT_START':
      {
        return state.setIn(pathToProducts, (state.getIn([].concat(pathToProducts)) || (0, _immutable.Map)()).merge((0, _immutable.Map)({ loading: true })));
      }

    case 'GET_PRODUCTS':
      {
        return (0, _immutable.fromJS)(action.payload).reduce(function (state, p) {
          return state.setIn([].concat(pathToProducts, [p.get('id')]), p);
        }, state);
      }

    case 'ADD_PRODUCT':
      return state.setIn([].concat(pathToProducts, [action.payload.id]), (0, _immutable.fromJS)(action.payload)).deleteIn([].concat(pathToProducts, ['loading']));

    case 'UPDATE_PRODUCT':
      return state.setIn([].concat(pathToProducts, [action.payload.id]), (0, _immutable.fromJS)(action.payload)).deleteIn([].concat(pathToProducts, ['loading']));

    case 'DELETE_PRODUCT':
      return state.deleteIn([].concat(pathToProducts, [action.product_id]));

    case 'GET_IMAGES_START':
      {
        return state.setIn(pathToImages, (0, _immutable.fromJS)({ loading: true }));
      }

    case 'GET_IMAGES':
      {
        return state.setIn(pathToImages, (0, _immutable.fromJS)(action.payload.map(function (i) {
          return i.id;
        })));
      }

    case 'UPLOAD_IMAGE':
      {
        return state.setIn(pathToImages, (state.getIn(pathToImages) || (0, _immutable.List)()).push((0, _immutable.fromJS)(action.payload.id)));
      }

    case 'DELETE_IMAGE':
      {
        return state.setIn(pathToImages, state.getIn(pathToImages).filter(function (i) {
          return i !== action.image_id;
        }));
      }

    case 'ADD_PRODUCT_ERROR':
    case 'UPDATE_PRODUCT_ERROR':
      {
        return state.deleteIn([].concat(pathToProducts, ['loading']));
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/products/index.js
// module id = 706
// module chunks = 0